
$(document).ready(function(){
    function updateSubmenuHeight(element) {
        var h = $(element).find('.wrap-submenu').innerHeight();
        if(h < 360){
          h =360;
        }
        
        console.log(h, element);
        document.documentElement.style.setProperty('--submenu-height', h + 'px');
        $('.mega-menu-horizontal__inner').css("--submenu-height",h +"px");
    }

    $(".nav_main_wrap .first-child").hover(
      function () {
        $(this).addClass('active');  
        updateSubmenuHeight(this);
        $('.mega-menu-horizontal__promo.slick-slider').slick('refresh');
      },
      function () {
        $(this).removeClass('active');  
        document.documentElement.style.setProperty('--submenu-height', '0px');
        $('.mega-menu-horizontal__inner').css("--submenu-height",360 +"px");
        $('.mega-menu-horizontal__promo.slick-slider').slick('refresh');
      }
    );
});
// accordian
  if ($(window).width() < 767) {
      $('body').on('click', '.footer-block--links p.footer-block__heading', function() {
          if($(this).parent().hasClass('active')){
              $(this).parent().removeClass('active');
              $(this).next().slideUp();
          }else{
              $('.footer-block--links p.footer-block__heading.active').next().slideUp();
              $('.footer-block--links p.footer-block__heading.active').removeClass('active');
              $(this).parent().addClass('active');
              $(this).next().slideDown();
          }
      });
  }
// get height header and announcement-bar 

    var announcement = $('.section-announcement-bar:visible').length ? $('.section-announcement-bar').innerHeight() : 0;
    var headerHeight = $('.section-site-header:visible').length ? $('.section-site-header').innerHeight() : 0;
    var total = announcement + headerHeight;

    if (!isNaN(total) && total > 0) {
        document.documentElement.style.setProperty('--header_height', total + 'px');
        console.log('--header_height:', total + 'px');
    }

//modal card js
$('body').off('click', '.card-swatches-main').on('click', '.card-swatches-main', function () {
  var variant_id = $(this).find('input').attr('data-variant-id');
  console.log("Selected Variant ID:", variant_id);

  $(this)
    .closest('.product-card__info')
    .find('.modal-buy-buttons input[name="id"]')
    .val(variant_id);

  var url = $(this)
    .closest('.product-card__info')
    .find('.product-name a')
    .attr('href');

  if (!url) {
    console.error("Product URL not found");
    return;
  }

  url = url.split('?')[0];

  produpdate(url, variant_id, $(this));
});


function produpdate(baseUrl, variant_id, el) {
  var updatedUrl = `${baseUrl}?variant=${variant_id}`;
  console.log("Fetching:", updatedUrl);
  $.ajax({
    url: updatedUrl,
    type: 'GET',
    success: function (data) {
      var $tempDiv = $('<div>').html(data);

      var shippingText = $tempDiv.find('.product-info__shipping-text').html();
      var btn_add = $tempDiv.find('product-form .btn-add-cart span').html();
      console.log(btn_add);
      el.closest('.product-card__info')
          .find('product-form .button-add-to-cart span').html(btn_add);
              el.closest('.product-card__info')
          .find('.product-info__shipping-card')
          .html('');
      if (shippingText) {
        el.closest('.product-card__info')
          .find('.product-info__shipping-card')
          .html(shippingText);
      } else {
        el.closest('.product-card__info')
          .find('.product-info__shipping-card')
          .html('');
      }
    },
    error: function (xhr, status, error) {
      console.error("Failed to fetch the page:", error);
    }
  });
}




// search
$(document).ready(function() {
  if ($(window).width() > 1199) {
    document.querySelector('search-modal')?.setAttribute('position', 'right');
  }
});
$('body').on('click', 'quick-add-modal .product-quick-add-modal', function() {
    var currentProductUrl = $('quick-add-modal .quick-add-modal-content a.product-title').attr("href");
  console.log(currentProductUrl);
  
    $(".product-card").each(function() {
        var loopUrl = $(this).find('.product-name a').attr("href");
        if(loopUrl == currentProductUrl){
            $(this).closest('.section-featured-collection').find('.modal-open').click();
            $(this).closest('.collection-grid').find('.modal-open').click();
          // $('body').addClass('overflow-hidden');
        }
    });
});


// Add to cart listener.
// document.addEventListener('product:added-to-cart', (e) => { 
//     console.log(e, 'eeee'); 
//     addCart();
// });

// Cart change listener.
// document.addEventListener('change', (e) => { 
//     console.log(e, 'eeeessssss'); 
//     addCart();
// });

let debounceTimer;

document.addEventListener('cart:reload', (e) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    // Only runs after user stops triggering events for 300ms
    console.log(e, 'cart:reload');
    addCart();
    autoAddCart();
  }, 800);
});

const button = document.querySelector('cart-form .button-checkout');

let carRefreshDebounce;

function cartRefresh(loadingOverlay=null){
    //clearTimeout(carRefreshDebounce);
    //carRefreshDebounce = setTimeout(() => {
    console.log('cart:refresh 42185304277015 41789183361047 ');
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
       document.dispatchEvent(new CustomEvent("product:added-to-cart",{
            detail: {
                quantity: 1
            }
        }))
      if(loadingOverlay != null){
        loadingOverlay.style.display = 'none';
        if(button){
        button.disabled = false;
        }
        $('body').removeClass('btn-disabled');
      }
    }
  //}, 300);

}

const variantId = null;

function autoAddCart() {
  if (window.location.pathname === '/cart') {

    var $wrap = $('.cart-items.custom-auto-add');
    if ($wrap.length) {
      var variantId = $wrap.data('auto-add-product');
      var shouldAdd = $wrap.hasClass('auto-add-product');
      var shouldRemove = $wrap.hasClass('remove-auto-product');
      var hasProduct = $wrap.hasClass('has_auto_product');
      var itemKey = $wrap.find('.is-surcharge').attr('data-cartItemKey');
      if (shouldRemove && hasProduct) {
     
      variantId =+ variantId;
      console.log('Global variantId cart page:', variantId);

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { id: itemKey, quantity: 0 },
        dataType: 'json'
      })
      .done(function () {
        console.log('Product removed from cart');
        stopLoading();
      })
      .fail(handleError);
      }
    }
  }
  var $wrap = $('#cart-modal .custom-auto-add');
  if ($wrap.length === 0) return;



  var variantId = $wrap.data('auto-add-product');
  var shouldAdd = $wrap.hasClass('auto-add-product');
  var shouldRemove = $wrap.hasClass('remove-auto-product');
  var hasProduct = $wrap.hasClass('has_auto_product');
  var itemKey = $wrap.find('.is-surcharge').attr('data-cartItemKey');

   console.log("variantId",variantId);
    window.checkGWD(variantId);

  // Prevent double processing
  if ($wrap.data('processing')) return;

  if (!variantId) {
    console.warn('Variant ID missing');
    return;
  }

  if (!shouldAdd && !shouldRemove) return;

  // ── Loader helpers ──────────────────────────────────────────────
  function getLoader() {
    var cartModalEl = document.querySelector('#cart-modal');
    if (cartModalEl && cartModalEl.shadowRoot) {
      var el = cartModalEl.shadowRoot.querySelector('.loading-overlay');
      if (el) return el;
    }
    return (
      document.querySelector('#cart-modal .loading-overlay') ||
      document.querySelector('.loading-overlay')
    );
  }

  var loadingOverlay = getLoader();

  function startLoading() {
    $wrap.data('processing', true);
    if (loadingOverlay) loadingOverlay.style.display = 'flex';
    $('body').addClass('btn-disabled');
  }

  function stopLoading() {
    if (loadingOverlay) loadingOverlay.style.display = 'none';
    $('body').removeClass('btn-disabled');
    $wrap.data('processing', false);

    if (typeof cartRefresh === 'function') {
      try {
        cartRefresh(loadingOverlay);
      } catch (e) {
        console.warn('cartRefresh failed:', e);
      }
    }
  }

  function handleError(err) {
    console.error('Cart error:', err);
    stopLoading();
  }

  // ── Add product ─────────────────────────────────────────────────
  if (shouldAdd && !hasProduct) {
    startLoading();

    window.checkGWD(variantId);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1,
        properties: { __surcharge: 'true' }
      },
      dataType: 'json',
    })
      .done(function () {
        console.log('Product added to cart');
         $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            id: variantId,
            quantity: 1,
            properties: { __surcharge: 'true' }
          },
          dataType: 'json'
        })
          .done(function (response) {
            console.log('Quantity enforced to 1:', response);
            stopLoading();
          })
        // stopLoading();
      })
      .fail(handleError);

    return;
  }

  // ── Remove product ──────────────────────────────────────────────
  if (shouldRemove && hasProduct) {
    startLoading();
    console.log('redyyy', $wrap);
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { id: itemKey, quantity: 0 },
      dataType: 'json'
    })
      .done(function () {
        console.log('Product removed from cart');
        stopLoading();
      })
      .fail(handleError);

      return;
      }

  // ── Nothing matched ─────────────────────────────────────────────
  stopLoading();
}
function addCart() {
  var $custWraps = $('.cust-shipping-wrap');
  if ($custWraps.length === 0) {
    console.log('No .cust-shipping-wrap elements found');
    return;
  }

  var adds = [];    // array of { id: variantId }
  var removes = []; // array of { key: lineKey }

  // collect actions for each cust-shipping-wrap
  $custWraps.each(function () {
    var $cust = $(this);

    // try multiple ways to read the variant id (data_id, data-id, data('id') etc.)
    var v_id = $cust.attr('data_id') || $cust.attr('data-id') || $cust.data('id') || $cust.data('variant-id');

    // find the .shipping-wrap related to this cust block (inside, or the element itself, or sibling)
    var $wrap = $cust.find('.shipping-wrap');
    if (!$wrap.length) $wrap = $cust.filter('.shipping-wrap');
    if (!$wrap.length) $wrap = $cust.siblings('.shipping-wrap').first();

    if (!$wrap.length) {
      console.log('shipping-wrap not found for', $cust);
      return; // continue each
    }

    // Decide action
    if ($wrap.hasClass('free-gift-added') && !$wrap.hasClass('have_product')) {
      if (v_id) {
        adds.push({ id: v_id });
      } else {
        console.warn('Variant id not found for add:', $cust);
      }
    } else if ($wrap.hasClass('free-gift-not-added')) {
      var key = $wrap.attr('data-key') || $wrap.data('key');
      if (key) {
        removes.push({ key: key });
      } else {
        // console.warn('data-key not found for remove on:', $wrap);
        // loadingOverlay.style.display = 'none';
      }
    }
  });

  if (adds.length === 0 && removes.length === 0) {
    console.log('Nothing to update in cart');
    return;
  }

  // show loading UI (support both shadowRoot and non-shadow)
  var cartModalEl = document.querySelector('#cart-modal');
  var loadingOverlay = null;
  if (cartModalEl && cartModalEl.shadowRoot) {
    loadingOverlay = cartModalEl.shadowRoot.querySelector('.loading-overlay');
  }
  if (!loadingOverlay) {
    loadingOverlay = document.querySelector('#cart-modal .loading-overlay') || document.querySelector('.loading-overlay');
  }
  if (loadingOverlay) loadingOverlay.style.display = 'flex';
  $('body').addClass('btn-disabled');

  // optionally disable a global button if it exists (safe guard)
  var origButtonDisabled;
  if (typeof button !== 'undefined' && button) {
    origButtonDisabled = button.disabled;
    button.disabled = true;
  }

  // helper to sequentially perform AJAX calls for adds
  function doAdds() {
    if (adds.length === 0) return Promise.resolve();
    var chain = Promise.resolve();
    adds.forEach(function (item) {
      chain = chain.then(function () {
        console.log('Adding variant', item.id);
        return $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { id: item.id, quantity: 1 },
          dataType: 'json'
        }).then(function (res) {
          console.log('Added', item.id, res);
          $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {
                  updates: {
                    [item.id]: 1
                  }
                },
                dataType: 'json',

                success: function (response) {
                  console.log('Updated quantity to 1', response);
                },

                error: function (xhr) {
                  console.log('Update failed', xhr.responseText);
                  if (button) button.disabled = false;
                }
              });
        }).catch(function (err) {
          console.error('Add error for', item.id, err);
           loadingOverlay.style.display = 'none';
        });
      });
    });
    return chain;
  }

  // helper to sequentially perform AJAX calls for removes
  function doRemoves() {
    if (removes.length === 0) return Promise.resolve();
    var chain = Promise.resolve();
    removes.forEach(function (item) {
      chain = chain.then(function () {
        console.log('Removing line key', item.key);
        return $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: { id: item.key, quantity: 0 },
          dataType: 'json'
        }).then(function (res) {
          console.log('Removed', item.key, res);
        }).catch(function (err) {
          console.error('Remove error for', item.key, err);
        });
      });
    });
    return chain;
  }

  // run adds then removes, then refresh cart once
  doAdds()
    .then(doRemoves)
    .then(function () {
      console.log('All add/remove operations finished');
      if (loadingOverlay) loadingOverlay.style.display = 'none';
      $('body').removeClass('btn-disabled');
      if (typeof button !== 'undefined' && button) button.disabled = origButtonDisabled;
      if (typeof cartRefresh === 'function') {
        try { cartRefresh(loadingOverlay); } catch (e) { console.warn('cartRefresh failed', e); }
      } else {
        console.log('cartRefresh not available to call');
      }
    })
    .catch(function (err) {
      console.error('Error in addCart sequence', err);
      if (loadingOverlay) loadingOverlay.style.display = 'none';
      $('body').removeClass('btn-disabled');
      if (typeof button !== 'undefined' && button) button.disabled = origButtonDisabled;
    });
}




// function addCart() {
//   let data;
  
//   var v_id = $('.cust-shipping-wrap').attr('data_id');
//   if ($('.shipping-wrap').hasClass("free-gift-added") && !$('.shipping-wrap.free-gift-added').hasClass("have_product")) {
//     data = {
//       id: v_id,
//       quantity: 1
//     };
//   } else if ($('.shipping-wrap').hasClass("free-gift-not-added")) {
//     data = {
//       id: v_id,
//       quantity: 0
//     };
//   }

 

//   if (data && data.quantity == 1) {
//     const cartModalEl = document.querySelector('#cart-modal');
//         const shadowRoot = cartModalEl.shadowRoot;
//         const loadingOverlay = shadowRoot.querySelector('.loading-overlay');
//           if (button) {
//             button.disabled = true;
//           }
//            $('body').addClass('btn-disabled');
//         loadingOverlay.style.display = 'flex';
//         // $.getJSON('/cart.js', function (cart) {
//         //   const v_id = data.id;

//         //   const alreadyAdded = cart.items.some(item => item.variant_id == v_id);
//         //    console.log('addCArt v_id v_id v_id v_id v_id', v_id);
//         //   // ❌ STOP if already in cart
//         //   if (alreadyAdded) {
//         //     console.log('Product already in cart, skipping add');
//         //     // $('.shipping-wrap.free-gift-added').addClass("have_product");
//         //     loadingOverlay.style.display = 'none';
//         //     if (button) button.disabled = false;
//         //     return;
//         //   }

//           // ✅ ADD TO CART ONLY IF NOT PRESENT
//           $.ajax({
//             type: 'POST',
//             url: '/cart/add.js',
//             data: data,
//             dataType: 'json',
//             success: function (response) {
//               $.ajax({
//                 type: 'POST',
//                 url: '/cart/update.js',
//                 data: {
//                   updates: {
//                     [data.id]: 1
//                   }
//                 },
//                 dataType: 'json',

//                 success: function (response) {
//                   console.log('Updated quantity to 1', response);
//                   cartRefresh(loadingOverlay);
//                   if (button) button.disabled = false;
//                 },

//                 error: function (xhr) {
//                   console.log('Update failed', xhr.responseText);
//                   if (button) button.disabled = false;
//                 }
//               });
              
//             },
//             error: function (xhr, status, error) {
//               console.log('error', error);
//               if (button) button.disabled = false;
//             }
//           });
//         // });
//   } else {
//     let key =  $('.shipping-wrap.free-gift-not-added').attr('data-key');
//     if($('.shipping-wrap').hasClass("free-gift-not-added") && key){
//       console.log('Nothing to update in cart');
//       const cartModalEl = document.querySelector('#cart-modal');
//         const shadowRoot = cartModalEl.shadowRoot;
//         const loadingOverlay = shadowRoot.querySelector('.loading-overlay');
        
//           if (button) {
//             console.log('disabled = true');
//             button.disabled = true;
//             $('body').addClass('btn-disabled');
//           }
//         loadingOverlay.style.display = 'flex';
      
//       $.ajax({
//         type: 'POST',
//         url: '/cart/change.js',
//         data: {
//           "id": key,
//           "quantity": 0
//         },
//         dataType: 'json',
//         success: function(response) {
//           console.log('done', response);
//           // Optional: dispatch a custom event if needed
//           cartRefresh(loadingOverlay);
          
//         },
//         error: function(xhr, status, error) {
//           console.log('error', error);
//         }
//       });
//     }
    
//   }
// }

// Upsell product
let debounceTimerCust;

window.cartJustReloaded = false;

// Attach cart:reload listener only once
if (!window.cartReloadListenerAttached) {
  document.addEventListener('cart:reload', (e) => {
    clearTimeout(debounceTimerCust);
    debounceTimerCust = setTimeout(() => {
      console.log(e, 'cart:reload');
      window.cartJustReloaded = true;
      // addCart_upsell(); // Assuming this is your function to refresh upsells
    }, 800);
  });

  window.cartReloadListenerAttached = true;
}
var $btn ;
// Click handler for upsell buttons
$('body').on('click', '.upsell-btn', function () {
   $btn = $(this);
  var $form = $(this).closest('form');
  var upsellVariantId = $form.find('input[name="id"]').val();
  var mainVariantId = $('.modal-open').closest('form').find('input[name="id"]').val();

  if (!upsellVariantId || !mainVariantId) {
    console.warn('Missing variant IDs');
    return;
  }

  if (!window.cartJustReloaded) {
    console.log('Upsell blocked: cart:reload not triggered yet');
    return;
  }
  $btn.prop('disabled', true)
    .attr('aria-loading', 'true')
    .addClass('pointer-events-none')
    .css('color', 'transparent')
    .data('original-html', $btn.html()) // Save original content to restore later
    .html(`
      <span style="opacity: 0;">${$btn.text().trim()}</span>
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    `);

  console.log('Upsell confirmed. Proceeding...');
  window.cartJustReloaded = false; 
  removeMainAndAddUpsell(mainVariantId, upsellVariantId);
});

// Remove main item and add upsell
function removeMainAndAddUpsell(mainVariantId, upsellVariantId) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const lineItem = cart.items.find(item => item.variant_id == mainVariantId);

      if (!lineItem) {
        console.warn('Main product not found in cart. Skipping removal.');
        return addUpsellOnly(upsellVariantId);
      }

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineItem.key,
          quantity: 0,
        }),
      })
        .then(res => res.json())
        .then(() => {
          console.log('Main product removed');
          addUpsellOnly(upsellVariantId);
        });
    })
    .catch(err => {
      console.error('Error in removeMainAndAddUpsell:', err);
    });
}

// Add only the upsell product and trigger cart:reload
function addUpsellOnly(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then(res => res.json())
    .then(data => {
      console.log('Upsell product added:', data);
      cartRefresh();
      $('#product-upsell-modal').removeClass('active');
      $('body').removeClass('overflow-hidden');
      // Dispatch event to re-trigger any upsell logic
      const event = new CustomEvent('cart:reload', {
        detail: { variantId },
      });
      document.dispatchEvent(event);
      $btn.html($btn.data('original-html'))
      .removeAttr('aria-loading')
      .removeClass('pointer-events-none')
      .css('color', '')
      .prop('disabled', false);
      addCart();
      autoAddCart();
    })
    .catch(err => {
      console.error('Error adding upsell product:', err);
    });
}



//countdown banner
jQuery(document).ready(function($) {

  $(".timer").each(function() {
    var $timer = $(this);
    var $daysWrap = $timer.find(".days-countdown");

    var date = $daysWrap.data("date");
    var time = $daysWrap.data("time") || "12:00";
    var endText = $daysWrap.data("endtext") || "Sale has ended!";
    var endDate = new Date(date + "T" + time).getTime();

    function updateCountdown() {
      var now = new Date();
      var nowDublin = new Date(now.toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
      var timestamp = nowDublin.getTime();

      var distance = endDate - timestamp;

      if (distance <= 0) {
        clearInterval(timerId);
        $timer.addClass("end-sale");
        $timer.html('<div class="end-sale">' + endText + '</div>');
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Split into digits
      $timer.find(".days1").text(Math.floor(days / 10));
      $timer.find(".days2").text(days % 10);

      $timer.find(".hours1").text(Math.floor(hours / 10));
      $timer.find(".hours2").text(hours % 10);

      $timer.find(".minutes1").text(Math.floor(minutes / 10));
      $timer.find(".minutes2").text(minutes % 10);

      $timer.find(".seconds1").text(Math.floor(seconds / 10));
      $timer.find(".seconds2").text(seconds % 10);
    }

    // Run immediately once
    updateCountdown();

    // Then every second
    var timerId = setInterval(updateCountdown, 1000);
  });

// Popup for CrunchBox 2.0 Register Interest Page Template "https://seedsprout.com.au/pages/crunchbox-2-0-register-your-interest"

(function () {
  console.log('[Klaviyo Debug] Script initialised');

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="#klaviyo-ukufad"]');
    if (!link) return;

    // Stop everything else (Instant, navigation, Shopify handlers)
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Remove instant navigation just in case
    link.removeAttribute('data-instant');

    if (!window._klOnsite) {
      window._klOnsite = [];
    }

    window._klOnsite.push(['openForm', 'UKUfad']);
  }, true); //  capture phase is critical
})();




});